import styled from 'styled-components'

export const Container = styled.div`
    & + & {
        margin-top: 2rem;
    }
`

export const Content = styled.div`
    display: flex;
    align-items: center;

    p {
        font-weight: 700;
    }
`